import Image from "next/image";
import Button from "./Button";

interface GoogleAuthButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  mode?: "signin" | "signup";
}

export default function GoogleAuthButton({
  onClick,
  isLoading = false,
  mode = "signin",
}: GoogleAuthButtonProps) {
  return (
    <Button
      type="button"
      className="w-full flex items-center justify-center gap-2 bg-surface border border-border text-foreground hover:bg-secondary"
      onClick={onClick}
      isLoading={isLoading}
    >
      {!isLoading && (
        <Image
          src="/images/google-logo.svg"
          alt="Google logo"
          width={18}
          height={18}
        />
      )}
      {mode === "signin" ? "Sign in with Google" : "Sign up with Google"}
    </Button>
  );
}
